<template>
  <path
    id="Trazado_3558"
    data-name="Trazado 3558"
    class="cls-1"
    d="M96.229 68.693a.887.887 0 1 0 .887.887.887.887 0 0 0-.887-.887z"
    transform="translate(-84.66 -65.992)"
  />
  <path
    id="Trazado_3559"
    data-name="Trazado 3559"
    class="cls-1"
    d="M91.381 69.982a3.725 3.725 0 1 0 3.725 3.725 3.73 3.73 0 0 0-3.725-3.725zm0 6.111a2.386 2.386 0 1 1 2.387-2.386 2.389 2.389 0 0 1-2.387 2.386z"
    transform="translate(-83.756 -66.144)"
  />
  <path
    id="Trazado_3560"
    data-name="Trazado 3560"
    class="cls-1"
    d="M93.819 80.758H87.78a4.548 4.548 0 0 1-4.544-4.543v-6.04a4.549 4.549 0 0 1 4.544-4.543h6.039a4.549 4.549 0 0 1 4.544 4.543v6.04a4.549 4.549 0 0 1-4.544 4.543zm-6.039-13.7a3.123 3.123 0 0 0-3.121 3.12v6.04a3.124 3.124 0 0 0 3.121 3.121h6.039a3.125 3.125 0 0 0 3.121-3.121v-6.04a3.124 3.124 0 0 0-3.121-3.12z"
    transform="translate(-83.236 -65.632)"
  />
</template>
